import * as React from 'react'

function SvgTh(props) {
	return (
		<svg viewBox="0 0 900 600" width="1em" height="1em" {...props}>
			<path fill="#A51931" d="M0 0h900v600H0z" />
			<path fill="#F4F5F8" d="M0 100h900v400H0z" />
			<path fill="#2D2A4A" d="M0 200h900v200H0z" />
		</svg>
	)
}

export default SvgTh
